import StatusBadge from "./StatusBadge";
import "./HowItWorks.css";

const steps = [
  {
    number: "01",
    status: "scheduled",
    body: "Connect your league once. The desk reads your ESPN or Sleeper rosters, scoring settings, and schedule.",
  },
  {
    number: "02",
    status: "onair",
    body: "While games run, it tracks every score and searches for real NFL context — injuries and news — behind every player that matters.",
  },
  {
    number: "03",
    status: "final",
    body: "When the last game ends, scores lock. MVPs, bench regret, and every boom and bust get gathered with the evidence to back them up.",
  },
  {
    number: "04",
    status: "filed",
    body: "Dispatches file Tuesday morning, one per matchup, delivered straight to every manager's inbox.",
  },
];

function HowItWorks() {
  return (
    <section id="how" aria-label="How it works" className="booth-shell booth-how">
      <div className="booth-how-header">
        <h2 className="booth-section-title">From kickoff to filed, while you sleep.</h2>
        <p className="booth-section-dek">
          Every matchup gets its own beat-writer recap — stats woven with narrative, and the receipts to back it up.
        </p>
      </div>
      <div className="booth-how-grid">
        {steps.map((step, i) => (
          <div
            key={step.number}
            className={`booth-how-step ${i === steps.length - 1 ? "booth-how-step--last" : ""}`.trim()}
          >
            <span className="booth-how-number">{step.number}</span>
            <StatusBadge state={step.status} />
            <span className="booth-how-body">{step.body}</span>
          </div>
        ))}
      </div>
    </section>
  );
}

export default HowItWorks;
